import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CatalogHost } from './data/catalog';
import { Observable } from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { parseCSV } from './parsing';

@Injectable()
export class StaticDataService {
  cache:{[key:string]:Observable<any>}={};

  constructor(private http:HttpClient) {

  }

  get(host:CatalogHost,path:string):Observable<any>{
    var url = `${host.url||''}${path}`;
    if(!this.cache[url]){
      const uniqueUrl = queryURL(url);
      this.cache[url] = this.http.get(uniqueUrl).pipe(
        publishReplay(),refCount());
    }

    return this.cache[url];
  }

  getCSV(host:CatalogHost,path:string):Observable<any>{
    var url = `${host.url||''}${path}`;
    if(!this.cache[url]){
      const uniqueUrl = queryURL(url);
      this.cache[url] = this.http.get(uniqueUrl,{
        responseType:'text'
      }).pipe(
        map(txt=>parseCSV(txt)),
        publishReplay(),
        refCount());
    }

    return this.cache[url];
  }
}

function queryURL(url:string): string {
  let uniqueUrl = url;
  if(uniqueUrl.indexOf('?')<0){
    uniqueUrl += '?';
  } else {
    uniqueUrl += '&'
  }
  return uniqueUrl + `time=${new Date().getTime()}`;
}
